import styled from 'styled-components';
import { baseTheme } from '../../../../../../global/styles/theme';

export const HistoryContainer = styled.div`
  width: 560px;
  max-width: calc(100vw - 64px);
  max-height: 70vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .history-title {
    font-size: 18px;
    font-weight: 700;
    color: ${baseTheme.colors.primary};
  }

  .history-entry {
    border: 1px solid ${baseTheme.colors.stroking};
    border-radius: 12px;
    padding: 12px;

    .entry-date {
      font-size: 13px;
      color: ${baseTheme.colors.tertiary};
      margin-bottom: 8px;
    }
  }

  .columns-header,
  .change-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
  }

  .columns-header {
    font-size: 12px;
    font-weight: 700;
    color: ${baseTheme.colors.tertiary};
    margin-bottom: 6px;
  }

  .column-cell {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    font-size: 13px;
    color: ${baseTheme.colors.secondary};
    padding: 3px 0;

    .cell-count {
      font-weight: 700;
      color: ${baseTheme.colors.primary};
      white-space: nowrap;
    }
  }
`;
